<template>
  <div>
    <PageTitle>
      <b-container>
        <h1 class="display-3">Schools</h1>
        <p class="lead">
          Here are the school information which all cost benefit analysis by
          this tool drawn from. <br />
          To update the schools information, upload a new CSV.
        </p>
      </b-container>
    </PageTitle>
    <b-overlay :show="loading" rounded="sm" no-wrap fixed />
    <b-container>
      <b-row>
        <b-col cols="4">
          <b-card no-body>
            <template v-slot:header>
              <b-card-title
                class="d-flex justify-content-between align-items-center"
              >
                Update schools information
              </b-card-title>
            </template>
            <b-card-body>
              <b-card-text>
                <b-alert
                  v-for="err in data_errors"
                  :key="err"
                  show
                  variant="danger"
                >
                  {{ err }}
                </b-alert>
                <vue-csv-import
                  :autoMatchFields="true"
                  :autoMatchIgnoreCase="true"
                  url="/"
                  v-model="csv"
                  :mapFields="input_fields"
                  :headers="true"
                  :canIgnore="false"
                  tableClass="table b-table table-striped table-hover border"
                  checkboxClass="custom-control-input"
                  buttonClass="btn btn-primary btn-block"
                  inputClass="custom-file-input"
                  @input="submit($event)"
                >
                </vue-csv-import>
                <!-- <vue-file-upload
                  :autoMatchFields="true"
                  :autoMatchIgnoreCase="true"
                  url="/"
                  v-model="csv"
                  :mapFields="input_fields"
                  :headers="true"
                  :canIgnore="false"
                  tableClass="table b-table table-striped table-hover border"
                  checkboxClass="custom-control-input"
                  buttonClass="btn btn-primary btn-block"
                  inputClass="custom-file-input"
                  @input="submit($event)"
                >
                </vue-file-upload> -->
              </b-card-text>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col>
          <Table
            :filter_toggle="true"
            :fields="fields"
            :items="items"
            :selectable="selectMultiple"
            @filter="onFilter"
            @deleteObject="deleteProject($event)"
          >
          </Table>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      id="response"
      title="Parameter update results"
      hide-footer
      no-stacking
    >
      <div class="d-block text-left">
        <p>{{ this.server_response }}</p>
      </div>
      <br />
      <b-row>
        <b-col>
          <b-button block variant="sgs-blue" @click="go_to('ProjectList')">
            View project list
          </b-button>
        </b-col>
        <b-col>
          <b-button block variant="sgs-green" @click="close()">
            Close
          </b-button>
        </b-col>
      </b-row>
      <!-- <b-button variant="secondary" @click="go_to_project_list">
        Close
      </b-button> -->
    </b-modal>
  </div>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue";
import Table from "@/components/Table.vue";
import VueCsvImport from "@/components/VueCsvImport.vue";

export default {
  name: "SchoolList",
  components: {
    PageTitle,
    Table,
    VueCsvImport,
  },
  props: {},
  data() {
    return {
      error: false,
      loading: false,
      fields: [
        {
          key: "school_name",
          label: "School",
          sortable: true,
        },
        {
          key: "level_of_schooling",
          label: "Level",
          sortable: true,
        },
        {
          key: "icsea",
          label: "ICSEA",
          format: "0,0",
          sortable: true,
        },
        {
          key: "cluster_name",
          label: "SCG",
          sortable: true,
        },
      ],
      items: [],
      input_fields: {
        school_id: { label: "school_id" },
        school_name: { label: "school_name" },
        level_of_schooling: { label: "level_of_schooling" },
        icsea: { label: "icsea" },
        cluster_name: { label: "cluster_name" },
        street: { label: "street" },
        suburb: { label: "suburb" },
        postcode: { label: "postcode" },
        school_population_gender: { label: "school_population_gender" },
      },
      data_errors: [],
    };
  },
  methods: {
    getSchools() {
      this.$store
        .dispatch("get", {
          url: "/school",
        })
        .then((response) => {
          this.loading = false;
          console.log(response.data.items);
          this.items = response.data.items;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error.response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submit(event) {
      console.log(event);
      this.loading = true;
      this.$store
        .dispatch("post", {
          data: event,
          url: "/school/update/csv",
        })
        .then((response) => {
          this.loading = false;
          console.log(response.data);
          this.server_response = response.data;
          this.$bvModal.show("response");
        })
        .catch((error) => {
          this.loading = false;
          console.log(error.response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    go_to(name) {
      this.$router.push({ name: name });
    },
  },
  mounted() {
    this.getSchools();
    if (!this.isAdmin) {
      this.$router.push({ name: "logout" });
    }
  },
  created() {},
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
};
</script>
